/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import StaffMemberRouteLinkItem from './StaffMemberRouteLinkItem';
import InstructionalMaterialsIcon from 'icons/PublishersIcon';

const messages = defineMessages({
  title: {id: 'navigation.publishers'},
});

const PublishersItem = () => (
  <StaffMemberRouteLinkItem
    iconBefore={InstructionalMaterialsIcon}
    route="midas/staff-member/instructional-materials/publishers"
    title={messages.title}
  />
);

export default PublishersItem;
